import { ThemeEvents } from '@theme/events';

/**
 * A custom element wrapping the Model Dimensions accordion text
 * (blocks/_model-dimensions-text.liquid). Same-product variant swaps don't
 * re-morph <main>, so this listens for the variant update event directly
 * and replaces itself with the freshly-rendered version, mirroring the
 * pattern in media-gallery.js.
 */
class ModelDimensionsText extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {CustomEvent<{ data: { html?: Document } }>} event
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;
    if (!source) return;

    const newContent = source.querySelector('model-dimensions-text');
    if (!newContent) return;

    this.replaceWith(newContent);
  };
}

if (!customElements.get('model-dimensions-text')) {
  customElements.define('model-dimensions-text', ModelDimensionsText);
}
